"use strict";

import stackParser from "error-stack-parser";
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$remoteExceptionHandler", function ($injector) {
  var $http = null;
  var floodingCount = 0;
  var floodingHash = "";
  var maxflooding = 3;
  return {
    logError: function logError(exception, cause) {
      if ($http == null) {
        $http = $injector.get("$http"); // avoid cyclic dependency...
      }

      // try to parse stack to send usable info to client
      var parsedStack;
      try {
        parsedStack = stackParser.parse(exception);
      } catch (e) {
        parsedStack = null;
      }
      var exceptionData = {
        name: exception.name,
        message: exception.message,
        stack: parsedStack,
        rawStack: exception.stack,
        location: document.location.href,
        userAgent: window.navigator.userAgent || window.navigator.vendor || window.opera
      };

      // genere un hash pour identifier si on est floodé par la meme exeption
      var hashCode = (exceptionData.name + exceptionData.message + exceptionData.location).split("").reduce(function (a, b) {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
      }, 0);
      if (hashCode === floodingHash) {
        floodingCount++;
      } else {
        floodingHash = hashCode;
        floodingCount = 0;
      }
      if (floodingCount > maxflooding) {
        if (floodingCount === maxflooding + 1 || floodingCount % 200 === 0) {
          console.log("silently flooding...");
        }
      } else {
        if (floodingCount === maxflooding) {
          exceptionData.message = "[Client side FLOODING] " + exceptionData.message;
        }
        $http.post("/rest/remote-logger/error", exceptionData, {
          silentError: true
        });
      }
    }
  };
});
ngModule.config(function ($provide) {
  var unhandledRejectionText = "Possibly unhandled rejection";
  $provide.decorator("$exceptionHandler", ["$delegate", "$remoteExceptionHandler", function ($delegate, $remoteExceptionHandler) {
    return function taelExceptionHandler(exception, cause) {
      $delegate.apply($delegate, arguments);
      var isUnhandlerRejectionError = _.isString(exception) && _.includes(exception, unhandledRejectionText);
      if (!isUnhandlerRejectionError) {
        $remoteExceptionHandler.logError(exception, cause);
      }
    };
  }]);
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/error/exceptionHandler.js
// module id = 2696
// module chunks = 13